import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as d, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconAiNotes",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ i("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 1.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5.5.5 0 1 1 1 0A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10V2A1.5 1.5 0 0 1 3 .5h4.25a.5.5 0 0 1 .354.146l1 1a.5.5 0 1 1-.707.708L7.043 1.5H3Z",
  "clip-rule": "evenodd"
}, null, -1), u = /* @__PURE__ */ i("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.978 3.455c0-.38.315-.655.661-.655.347 0 .661.275.661.655s-.314.655-.66.655a.658.658 0 0 1-.662-.655Zm-3.506.5c-.174 0-.42.146-.545.527v.002L4.674 8.257a.5.5 0 0 1-.95-.314L4.977 4.17c.211-.643.752-1.216 1.496-1.216s1.283.57 1.495 1.213l.964 2.906c.124.38.37.526.545.526.398 0 .663-.294.663-.588v-1.99a.5.5 0 0 1 1 0v1.99c0 .908-.777 1.588-1.663 1.588-.743 0-1.284-.57-1.495-1.213l-.964-2.905V4.48c-.125-.38-.37-.526-.545-.526Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _,
  u
];
function f(a, h, r, p, v, e) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--ai-notes"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Ai Notes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const C = /* @__PURE__ */ n(s, [["render", f]]);
export {
  C as default
};
//# sourceMappingURL=ai-notes.js.map
